// extracted by mini-css-extract-plugin
module.exports = {"cookiesSettingWrapper":"settingList_cookiesSettingWrapper__5wJvc","title":"settingList_title__j_ajc","status":"settingList_status__E6STN","content":"settingList_content__mSUob"};